import script from "./NewsDetailEN.vue?vue&type=script&setup=true&name=NewsDetail&lang=js"
export * from "./NewsDetailEN.vue?vue&type=script&setup=true&name=NewsDetail&lang=js"

import "./NewsDetailEN.vue?vue&type=style&index=0&id=6c358385&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c358385"]])

export default __exports__